module.exports = __webpack_public_path__ + "static/media/external_3.cd09ffec.jpg";